var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeEnergy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2591 9.59554L15.6241 4.12953C15.2192 3.83968 15.0168 3.69474 14.7959 3.63868C14.6008 3.58919 14.3965 3.58919 14.2014 3.63868C13.9806 3.69474 13.7782 3.83968 13.3733 4.12953L5.73825 9.59556M23.2591 9.59554L25.9779 11.5419M23.2591 9.59554V12.8034M5.73825 9.59556L3.01953 11.5419M5.73825 9.59556V18.6696C5.73825 20.6999 5.73825 21.7149 6.13335 22.4904C6.48089 23.1725 7.03545 23.727 7.71753 24.0745C8.49297 24.4696 9.50806 24.4696 11.5382 24.4696H15.4049",
    stroke: "white",
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9806 16.943C22.9806 16.3517 22.2552 16.0868 21.8891 16.5445L18.2653 21.0746C17.9365 21.4854 18.2224 22.1024 18.7415 22.1024H20.5194V24.7445C20.5194 25.3359 21.2448 25.6008 21.6109 25.143L25.2347 20.613C25.5635 20.2022 25.2776 19.5852 24.7585 19.5852H22.9806V16.943Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1758 14.5007C11.1758 12.6654 12.6635 11.1777 14.4987 11.1777C16.3339 11.1777 17.8216 12.6654 17.8216 14.5007C17.8216 16.3359 16.3339 17.8236 14.4987 17.8236C12.6635 17.8236 11.1758 16.3359 11.1758 14.5007Z",
    fill: "white",
    fillOpacity: 0.5,
    stroke: "white",
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeEnergy);
export default __webpack_public_path__ + "static/media/home-energy.1e83f88d811cc07801916bfc5489b898.svg";
export { ForwardRef as ReactComponent };